export default "__VITE_ASSET__BdBfD9Lw__"